import { Path, Svg } from '../../compiler'

const MessageIcon = () => {
  return (
    <Svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <Path
        d='M1 9.34861C1 10.3488 1.73847 11.2002 2.73405 11.2959C2.82262 11.3045 2.91127 11.3127 3 11.3207V13.75C3 14.0533 3.18273 14.3268 3.46299 14.4429C3.74324 14.559 4.06583 14.4948 4.28033 14.2803L6.10018 12.4605C5.72131 11.9012 5.5 11.2264 5.5 10.5V9.5C5.5 7.567 7.067 6 9 6H13V4.65148C13 3.65133 12.2615 2.79993 11.266 2.70415C9.86223 2.5691 8.43918 2.5 7 2.5C5.56082 2.5 4.13777 2.5691 2.734 2.70415C1.73845 2.79993 1 3.65133 1 4.65148V9.34861Z'
        fill='#4461D4'
      />
      <Path
        d='M7 9.5C7 8.39543 7.89543 7.5 9 7.5H13C14.1046 7.5 15 8.39543 15 9.5V10.5C15 11.6046 14.1046 12.5 13 12.5H12.75V13.75C12.75 14.0533 12.5673 14.3268 12.287 14.4429C12.0068 14.559 11.6842 14.4948 11.4697 14.2803L9.68934 12.5H9C7.89543 12.5 7 11.6046 7 10.5V9.5Z'
        fill='#4461D4'
      />
    </Svg>
  )
}

export default MessageIcon
